import { API_BASE } from '@/env';

function getFileUrlInternal(id: string, thumbnail = false): string {
  if (!id) return '';

  const filePath = thumbnail ? 'file-thumbnail' : 'file';
  return `${API_BASE}/${filePath}/${id}`;
}

export const getFileUrl = getFileUrlInternal;
